module.exports = __webpack_public_path__ + "static/media/a12_lighting.ac6e055b.png";